import axios from 'axios';

// This instance includes the interceptor for authorization
const apiWithAuth = axios.create({
  baseURL: process.env.REACT_APP_NUPITCH_API_URL
});

apiWithAuth.interceptors.request.use(
  config => {
    const jwt = localStorage.getItem('jwt');
    config.headers.Authorization = jwt ? `Bearer ${jwt}` : '';
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// This instance does not include the interceptor for authorization
const apiWithoutAuth = axios.create({
  baseURL: process.env.REACT_APP_NUPITCH_API_URL
});

const interceptor = {
  apiWithAuth,
  apiWithoutAuth
};

export default interceptor;
